import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AppointmentState } from '@work4all/models/lib/Classes/AppointmentState.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { hexToSignedInt } from '@work4all/utils/lib/colorConversion';

import { EditTableColumns } from '../../../containers/mask-overlays/mask-overlay/views/erp/components/tab-panels/positions/components/edit-table/types';
import { EditableEntityTable } from '../editable-entity-table/EditableEntityTable';

const APPOINTMENTSTATE_DATA: AppointmentState = {
  id: null,
  name: null,
  hexColorForeground: null,
  color: null,
  outOfOffice: null,
};

const newEntryMandatoryFields: (keyof AppointmentState)[] = [
  'name',
  'hexColorForeground',
];

export const AppointmentStateTable = () => {
  const { t } = useTranslation();

  const cols = useMemo<EditTableColumns<AppointmentState>[]>(
    () => [
      {
        Header: t('COMMON.NAME'),
        accessor: 'name',
        width: 300,
        type: 'text',
      },
      {
        Header: t('COMMON.APPOINTMENT_STATE.OUT_OF_OFFICE'),
        accessor: 'outOfOffice',
        width: 100,
        type: 'checkbox',
      },
      {
        Header: t('COMMON.APPOINTMENT_STATE.COLOR'),
        accessor: 'hexColorForeground',
        width: 100,
        type: 'color',
      },
    ],
    [t]
  );

  return (
    <EditableEntityTable<AppointmentState>
      columns={cols}
      dataFields={APPOINTMENTSTATE_DATA}
      entity={Entities.appointmentState}
      idType="number"
      newEntryMandatoryFields={newEntryMandatoryFields}
      enableDelete={false}
      dataProviderProps={{
        completeDataResponse: true,
      }}
      transformBeforeUpdate={(value) => {
        return {
          ...value,
          color: value.hexColorForeground
            ? hexToSignedInt(value.hexColorForeground)
            : undefined,
          hexColorForeground: undefined,
        };
      }}
    />
  );
};
